import { isNothing } from "../../../common/utils";
import { SocialIcon } from "../ui/icons";

export const SocialLink: React.FC<{
    className?: string,
    href?: string
    type: SocialType
    isLive?: boolean
    onlyLive?: boolean
}> = ({ className, type, href, isLive, onlyLive }) => {
    const isActive = !isNothing(href);
    const imgBlock = <SocialIcon isLive={isLive} onlyLive={onlyLive} className={className} type={type} isActive={isActive} />

    if (href)
        return <a href={href} target="_blank">
            {imgBlock}
        </a>

    return imgBlock
};